var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.25H12.2503L9.64969 0.3C9.38967 0.105989 9.07411 0.000804693 8.74969 0H4.5C4.10218 0 3.72064 0.158035 3.43934 0.43934C3.15804 0.720644 3 1.10218 3 1.5V3H1.5C1.10218 3 0.720644 3.15804 0.43934 3.43934C0.158035 3.72064 0 4.10218 0 4.5V15C0 15.3978 0.158035 15.7794 0.43934 16.0607C0.720644 16.342 1.10218 16.5 1.5 16.5H15.8334C16.209 16.4995 16.569 16.3501 16.8346 16.0846C17.1001 15.819 17.2495 15.459 17.25 15.0834V13.5H18.8334C19.209 13.4995 19.569 13.3501 19.8346 13.0846C20.1001 12.819 20.2495 12.459 20.25 12.0834V3.75C20.25 3.35218 20.092 2.97064 19.8107 2.68934C19.5294 2.40804 19.1478 2.25 18.75 2.25ZM15.75 15H1.5V4.5H5.74969L8.55 6.6C8.67982 6.69737 8.83772 6.75 9 6.75H15.75V15ZM18.75 12H17.25V6.75C17.25 6.35218 17.092 5.97064 16.8107 5.68934C16.5294 5.40804 16.1478 5.25 15.75 5.25H9.25031L6.64969 3.3C6.38967 3.10599 6.07411 3.0008 5.74969 3H4.5V1.5H8.74969L11.55 3.6C11.6798 3.69737 11.8377 3.75 12 3.75H18.75V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentList);
export default ForwardRef;